import { useEffect, useRef } from 'react'
import { required, useSaveContext } from 'react-admin'
import { useFormContext, useWatch } from 'react-hook-form'

import config from './config'
import AdvancedReferenceInput from '../../components/AdvancedReferenceInput'
import hubsConfig from '../hubs/config'
import organisationsConfig from '../organisations/config'

const VehicleReferenceInput = ({
  filter,
  linkedToHub = true,
  readOnly = false,
  source = config.options.referenceKey,
  ...props
}) => {
  const [organisationId, hubId] = useWatch({
    name: [organisationsConfig.options.referenceKey, hubsConfig.options.referenceKey],
  })
  const { getValues, setValue } = useFormContext()
  const previousParents = useRef({ organisationId, hubId })
  const isFormTypeFilter = !useSaveContext().mutationMode

  useEffect(() => {
    const organisationChanged =
      previousParents.current.organisationId && previousParents.current.organisationId !== organisationId
    const hubChanged = linkedToHub && previousParents.current.hubId && previousParents.current.hubId !== hubId
    previousParents.current = { organisationId, hubId }

    if ((organisationChanged || hubChanged) && getValues(source)) {
      setValue(source, null, { shouldDirty: true })
    }
  }, [getValues, hubId, linkedToHub, organisationId, setValue, source])

  return (
    <AdvancedReferenceInput
      disableAutoSelect={!organisationId || (linkedToHub && !hubId)}
      filter={{
        ...config.options.defaultFilterValues,
        organisation_id: organisationId,
        hub_id: linkedToHub ? hubId : null,
        ...filter,
      }}
      readOnly={isFormTypeFilter ? false : (linkedToHub ? !hubId : !organisationId) || readOnly}
      reference={config.name}
      sort={config.options.defaultSort}
      source={source}
      validate={required()}
      {...props}
    />
  )
}

export default VehicleReferenceInput
